import clsx from 'clsx';
import React, { FC, PropsWithChildren } from 'react';

import styles from './styles.module.css';

interface Props {
  className?: string;
}

const EmblaSlide: FC<PropsWithChildren<Props>> = ({ children, className }) => {
  return <div className={clsx(styles.emblaSlide, className)}>{children}</div>;
};

export default EmblaSlide;
